import React, { useEffect } from 'react';
import ScrollReveal from 'scrollreveal';
import LordIconLazy from '../components/LordIconLazy/LordIconLazy';
import styles from './SecondScreen.module.css';
import compass from "../icons/wired-outline-74-navigation-hover-pinch.json";
import budget from "../icons/wired-outline-1010-department-hover-pinch.json";
import calendar from "../icons/wired-outline-472-hourglass-hover-rotation (2).json";
import target from "../icons/wired-outline-1140-error-hover-enlarge (1).json";

/* ========================================
   LordIcon - lazy-loaded (lottie kept out of the main bundle)
======================================== */
const LordIcon = ({ data }) => (
  <LordIconLazy data={data} className={styles.iconWrapper} colorize="#5d6b5e" />
);

const MazalTovSection = () => {
  const questions = [
    {
      iconData: compass,
      title: "מאיפה בכלל מתחילים?",
      description: "קבלן? אדריכל? מעצבת? מה קודם למה ומי אחראי על מה?"
    },
    {
      iconData: budget,
      title: "איך לא חורגים מהתקציב?",
      description: "כולם מספרים סיפורי אימה על פרויקטים שהתייקרו פי שניים. איך מוודאים שזה לא קורה לכם?"
    },
    {
      iconData: calendar,
      title: "כמה זמן זה באמת ייקח?",
      description: "ואיך דואגים שלא תתקעו חודשים עם דירה הפוכה או עסק שלא נפתח?"
    },
    {
      iconData: target,
      title: "איך יודעים שלא טועים?",
      description: "שהבחירות שתעשו היום לא יהפכו לחרטות של מחר?"
    }
  ];

  useEffect(() => {
    const sr = ScrollReveal({
      distance: '25px',
      duration: 1400,
      easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
      reset: false,
      viewFactor: 0.15,
    });

    sr.reveal(`.${styles.iconWrapper}`, {
      origin: 'left',
      interval: 250,
    });

    sr.reveal(`.${styles.cardTitle}`, {
      origin: 'right',
      interval: 250,
      delay: 200,
    });

    sr.reveal(`.${styles.cardDescription}`, {
      origin: 'bottom',
      interval: 250,
      delay: 400,
    });

    sr.reveal(`.${styles.secondTitleContainer}`, {
      origin: 'bottom',
      delay: 200,
    });

    return () => sr.destroy();
  }, []);

  return (
    <section className={styles.section}>
      {/* Header */}
      <div className={styles.headerContainer}>
        <h2 className={styles.mainTitle}>מזל טוב! אתם יוצאים לדרך חדשה</h2>
        <p className={styles.subtitle}>
          בין אם רכשתם נכס חדש, פותחים עסק, או סוף סוף מגשימים את השיפוץ שדיברתם עליו שנים - זה רגע מרגש.
          אבל רגע לפני ששוברים את הקיר הראשון או חותמים עם ספק -
        </p>
      </div>

      {/* Grid Subtitle */}
      <h3 className={styles.gridSubtitle}>אני בטוחה שכבר שאלתם את עצמכם:</h3>

      {/* Questions Grid */}
      <div className={styles.grid}>
        {questions.map((question, index) => (
          <div key={index} className={styles.card}>
            <div className={styles.cardInner}>
              <div className={styles.cardHeader}>
                <LordIcon data={question.iconData} />
                <h3 className={styles.cardTitle}>{question.title}</h3>
              </div>
              <p className={styles.cardDescription}>{question.description}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Second Title */}
      <div className={styles.headerContainer}>
        <h2 className={styles.mainTitle}>ואני מבינה אתכם לגמרי</h2>
        <p className={styles.subtitle}>
          כי כשתהליך של שיפוץ או עיצוב לא מנוהל נכון מההתחלה - הטעויות לא מחכות, הן פשוט קורות אחת אחרי השנייה, ובדרך כלל הן קורות כשכבר מאוחר מדי לתקן בלי לשלם על זה ביוקר
        </p>
      </div>
      <div className={styles.secondTitleContainer}>
        <h2 className={styles.secondTitle}>
          אבל כשיש לכם מעצבת פנים שהיא גם מנהלת פרויקטים..
        </h2>
      </div>
    </section>
  );
};

export default MazalTovSection;